let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2uUTw")).then(() => parcelRequire('hN51X'));